module.exports = __webpack_public_path__ + "static/media/6.a2ca7fb1.jpeg";